import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { PencilRuler, Plus, Trash2, Car, Ship, Bike, Ruler, Clock } from "lucide-react";

const CAT_ICON = { auto: Car, marine: Ship, moto: Bike };

export default function Etudes() {
  const navigate = useNavigate();
  const [studies, setStudies] = useState([]);
  const load = () => api.get("/studies").then((r) => setStudies(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    const { data } = await api.post("/studies", { title: "Nouvelle étude" });
    navigate(`/etudes/${data.id}`);
  };
  const remove = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm("Supprimer cette étude ?")) return;
    await api.delete(`/studies/${id}`); load(); toast.success("Étude supprimée");
  };

  return (
    <div className="space-y-6 animate-fade-up" data-testid="etudes-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-navy flex items-center justify-center"><PencilRuler className="w-5 h-5 text-sky-400" /></div>
          <div>
            <h1 className="text-3xl font-display font-bold text-navy">Études photo</h1>
            <p className="text-slate-500">Prenez des photos, calibrez l'échelle et tracez vos cotes pour préparer vos gabarits.</p>
          </div>
        </div>
        <button onClick={create} data-testid="etude-create-btn"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-navy text-white text-sm font-semibold hover:bg-navy-deep">
          <Plus className="w-4 h-4" /> Nouvelle étude
        </button>
      </div>

      {studies.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-slate-200 p-12 text-center text-slate-400">
          <Ruler className="w-8 h-8 mx-auto mb-2 opacity-40" />
          Aucune étude pour l'instant. Créez-en une pour commencer.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {studies.map((s) => {
            const Icon = CAT_ICON[s.category] || Ruler;
            const cover = (s.photos || []).find((p) => p.url);
            return (
              <button key={s.id} onClick={() => navigate(`/etudes/${s.id}`)} data-testid={`etude-card-${s.id}`}
                className="text-left bg-white rounded-2xl border border-slate-200 overflow-hidden hover:border-sky-300 hover:shadow-lg transition-all group">
                <div className="h-32 bg-slate-100 flex items-center justify-center overflow-hidden">
                  {cover ? (
                    <img src={`${cover.url.includes("/api/files/") ? `${cover.url}${cover.url.includes("?") ? "&" : "?"}auth=${localStorage.getItem("fabriko_token")}` : cover.url}`}
                      alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                  ) : (
                    <Icon className="w-8 h-8 text-slate-300" />
                  )}
                </div>
                <div className="p-4">
                  <div className="flex items-start justify-between gap-2">
                    <h3 className="font-display font-semibold text-navy leading-tight">{s.title}</h3>
                    <span onClick={(e) => remove(e, s.id)} data-testid={`etude-delete-${s.id}`} className="p-1 rounded-lg text-slate-300 hover:text-rose-500 hover:bg-rose-50"><Trash2 className="w-4 h-4" /></span>
                  </div>
                  <p className="text-xs text-slate-500 mt-1 truncate">{[s.brand, s.model].filter(Boolean).join(" ") || "Sans véhicule"}{s.client_name ? ` · ${s.client_name}` : ""}</p>
                  <div className="flex items-center gap-3 mt-3 text-[11px] text-slate-400">
                    <span className="inline-flex items-center gap-1"><Ruler className="w-3 h-3" /> {(s.photos || []).length} photo(s)</span>
                    {s.ai_summary && <span className="inline-flex items-center gap-1 text-emerald-500">Note IA</span>}
                    <span className="inline-flex items-center gap-1 ml-auto"><Clock className="w-3 h-3" /> {new Date(s.updated_at).toLocaleDateString("fr-FR")}</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
